import { Pagination, Row } from "antd";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../../components/atomics/primary-button";
import SecureLayout from "../../../components/layouts/secure-layout";
import { MachineSearchFilterModel, MachineSearchSortField } from "../../../service";
import { SearchMachineModel } from "../../../service/models/ExtendedMachineDetailModel";
import { extendedMachineDetailAtom, loadingAtom, userAtom } from "../../../store/global-atoms";
import { useSecureService } from "../../../store/service-atoms";
import { t } from "../../../translate";
import MachineSaleListFilter from "../../../components/atomics/machine-sale-list-filter";
import SaleMachineListCard from "../../../components/atomics/sale-machine-list-card";
import { ReactComponent as PlusB } from "../../../components/assets/plus-black.svg";
import style from "./list.module.scss"

const ListLessorSaleMachines = () => {
    const navigate = useNavigate();
    const [user] = useAtom(userAtom);
    const [, editMachine] = useAtom(extendedMachineDetailAtom);
    const [activePage, setActivePage] = useState<number | undefined>(1);
    const [totalItems, setTotalItems] = useState<number | undefined>(0);
    const { doSearchMachine } = useSecureService();
    const [loading] = useAtom(loadingAtom);
    const [filterObj, setFilterObj] = useState<{
        filterModel: MachineSearchFilterModel;
        sortBy: {
            field: MachineSearchSortField;
            sortAscending: boolean;
        };
    }>({
        filterModel: {
            onlySaleMachines: true,
        },
        sortBy: {
            field: MachineSearchSortField.CreationDate,
            sortAscending: false,
        },
    });
    const [machines, setMachines] = useState<SearchMachineModel>({});
    const pageSize = 6;
    useEffect(() => {
        getMachines();
        //eslint-disable-next-line
    }, [activePage, filterObj]);

    const getMachines = async () => {
        const machines = await doSearchMachine({
            pageNo: activePage,
            pageSize: pageSize,
            filter: filterObj.filterModel,
            sortAscending: filterObj.sortBy.sortAscending,
            sortBy: filterObj.sortBy.field,
        });
        if (machines) {
            setMachines(machines);
            setActivePage(machines.pageNo);
            setTotalItems(machines.itemCount);
        }
    };

    const pageChange = (page: number) => {
        setActivePage(page);
    };

    const viewClick = (machineId: number | undefined) => {
        editMachine(undefined);
        navigate("/sale-machines/detail?macid=" + machineId);
    };

    return (
        <SecureLayout
            activePage={"lessor-sale-machines"}
            role={"lessor"}
            title={t("machines.list.title") + " (" + (machines.itemCount ?? 0) + ")"}
            description={t("machines.list.description")}
            helperButtons={[
                <PrimaryButton
                    loading={loading}
                    onClick={() => {
                        editMachine(undefined);
                        navigate("/sale-machines/add?compid=" + user?.id);
                    }}                    
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: "240px" }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <PlusB style={{ marginRight: "0.5rem" }} />
                        {t("common.addNewSaleMachine")}
                    </div>
                </PrimaryButton>,
            ]}
        >
            <MachineSaleListFilter
                onChange={(params) => {
                    setFilterObj({
                        filterModel: params.searchFilterModel || {},
                        sortBy: params.sortBy,
                    });
                }}
            ></MachineSaleListFilter>
            <Row gutter={[16, 16]} style={{ marginBottom: "2rem" }}>
                {machines.machines?.map((mach) => {
                    return <SaleMachineListCard onViewClick={viewClick} machine={mach} xs={24} md={8} />;
                })}
            </Row>
            <Row className={style.mobilePagination}>
                <Pagination showSizeChanger={false} responsive defaultCurrent={activePage} pageSize={pageSize} total={totalItems} onChange={pageChange} />
            </Row>
        </SecureLayout>
    );
};

export default ListLessorSaleMachines;
